import { Typography, SuccessIcon, Button, Modal } from 'components'

type Props = {
	isModalOpen: boolean
	onCloseModal: (navigateToProject: boolean) => void
	projectName?: string
}

const CollaboratorInvitationSuccessModal = ({
	isModalOpen,
	onCloseModal,
	projectName
}: Props) => (
	<Modal
		className='flex flex-col items-center px-10 py-10'
		isOpen={isModalOpen}
		onCloseModal={() => onCloseModal(false)}
	>
		<SuccessIcon />

		<Typography
			class='mb-10 mt-6 text-center'
			text={`${projectName} was successfully added to your Projects`}
			variant='h1'
		/>

		<Button onClick={() => onCloseModal(true)} text='Go to Project' />
	</Modal>
)

export { CollaboratorInvitationSuccessModal }
